<mbs-table-grid
  [data]="licenses() || []"
  [entityName]="'shared:licenses.title' | i18next: { format: 'title' }"
  [headers]="headers()"
  [loading]="loading()"
  [disableViewSwitch]="true"
  [maxHeight]="tableMaxHeight()"
  [minHeight]="'50px'">
  <ng-template
    let-license
    mbsTableCell>
    {{ license.licenseType?.displayName }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ license.unitPrice | pricePrepayment | async }}
  </ng-template>

  @if (isProratedColumnShown()) {
    <ng-template
      let-license
      mbsTableCell>
      {{ license?.unitProratedPrice ? (license.unitProratedPrice | pricePrepayment | async) : ('shared:licenses.notApplicable' | i18next) }}
    </ng-template>
  }

  <ng-template
    let-license
    mbsTableCell>
    {{ (license.discount | number: '1.2-2') + '%' }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ license.unitTotalPrice | pricePrepayment: period() | async }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ license.quantity }}
  </ng-template>

  <ng-template
    let-license
    mbsTableCell>
    {{ license.lineItemPrice | pricePrepayment: period() | async }}
  </ng-template>
</mbs-table-grid>
